<script setup>
import { computed, onMounted, onUnmounted } from 'vue'
import TagesRaster from './TagesRaster.vue'

const props = defineProps({
  matches: { type: Array, default: () => [] },   // Spiele EINES Tages
  label: { type: String, default: '' },
  ziel: { type: [String, Object], default: 'body' }
})
const emit = defineEmits(['close', 'select', 'prev', 'next'])

// Badge-Text für Live-Spiele: 'HT' oder Minute, sonst leer
function spieluhr(m) {
  if (m.status !== 'live') return ''
  if (m.spielUhrKurz === 'HT') return 'HT'
  return m.minute ? `${m.minute}'` : 'Live'
}

const tage = computed(() => [{
  key: 'tag',
  label: '',
  spalten: [{ id: 'spiele', name: `${props.matches.length} Spiele` }],
  eintraege: props.matches.map(m => ({
    id: String(m.id),
    spalteId: 'spiele',
    start: new Date(m.zeit),
    titel: `${m.heim} – ${m.auswaerts}`,
    heim: m.heim,
    auswaerts: m.auswaerts,
    heimLogo: m.heimLogo,
    auswaertsLogo: m.auswaertsLogo,
    toreHeim: (m.status === 'beendet' || m.status === 'live') ? m.heimtore : null,
    toreAus:  (m.status === 'beendet' || m.status === 'live') ? m.austore  : null,
    liga: m.ligaKurz,
    flagge: m.ligaFlaggeBild,
    story: !!(m.storyPreview || m.storyReport),
    badge: spieluhr(m),
    status: m.status
  }))
}])

function waehle(e) {
  const m = props.matches.find(x => String(x.id) === e.id)
  if (m) emit('select', m)
}

function onKey(e) {
  if (e.key === 'Escape') emit('close')
  else if (e.key === 'ArrowLeft') emit('prev')
  else if (e.key === 'ArrowRight') emit('next')
}
onMounted(() => window.addEventListener('keydown', onKey))
onUnmounted(() => window.removeEventListener('keydown', onKey))
</script>

<template>
  <Teleport :to="ziel">
    <div class="tm-raster-backdrop" @click.self="emit('close')">
      <div class="tm-raster-modal" role="dialog" aria-modal="true">
        <div class="tm-raster-kopf">
          <div class="tm-raster-nav">
            <button type="button" class="tm-raster-pfeil" aria-label="Vorheriger Tag" @click="emit('prev')">‹</button>
            <span class="tm-raster-titel">{{ label }}</span>
            <button type="button" class="tm-raster-pfeil" aria-label="Nächster Tag" @click="emit('next')">›</button>
          </div>
          <button type="button" class="tm-raster-close" aria-label="Schließen" @click="emit('close')">✕</button>
        </div>
        <div class="tm-raster-inhalt">
          <TagesRaster :tage="tage" spaltenbreite="1fr" @select="waehle" />
        </div>
      </div>
    </div>
  </Teleport>
</template>